import { render, staticRenderFns } from "./biLog.vue?vue&type=template&id=24a5ad2e&scoped=true&"
import script from "./biLog.vue?vue&type=script&lang=js&"
export * from "./biLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5ad2e",
  null
  
)

export default component.exports